import AsyncStorage from "@react-native-async-storage/async-storage";
import { createClient } from "@supabase/supabase-js";
import "react-native-url-polyfill/auto";
import { useUserStore } from "../store/user";

const supabaseUrl = "https://unvtloluuxmtqcbtqmpb.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVudnRsb2x1dXhtdHFjYnRxbXBiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ4ODIyMDYsImV4cCI6MjA1MDQ1ODIwNn0.I_QfqX1-dRNLu-ad-58uwVtAIuKg_-blgfFwQ3XGLeY";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: AsyncStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});

export const updateAuth = async () => {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const newuser = {
    email: "",
    fullName: "Unknown",
    profileImage: "",
    isLoggedIn: false,
  };
  if (session?.user) {
    console.log("Logged in:", session?.user);
    newuser.email = session?.user.email ?? "";
    newuser.fullName = session?.user.user_metadata.full_name ?? "Unknown";
    newuser.profileImage = session?.user.user_metadata.avatar_url ?? "";
    newuser.isLoggedIn = true;
  }
  useUserStore.getState().setUser(newuser);
};
